window.HMAPPositionsSettingsForm = function ($scope, brand) {
    var self = this;

    self.brandId = brand.id;
    self.scope = $scope;
};
